export class Route_eCMRHandlingAndTransportationDto {
	public handlingAndTransportation: string;
	public reset: boolean;

	public static buildReset(): Route_eCMRHandlingAndTransportationDto {
		let result: Route_eCMRHandlingAndTransportationDto = new Route_eCMRHandlingAndTransportationDto();
		result.reset = true;
		return result;
	}

	public static build(handlingAndTransportation: string): Route_eCMRHandlingAndTransportationDto {
		let result: Route_eCMRHandlingAndTransportationDto = new Route_eCMRHandlingAndTransportationDto();
		result.handlingAndTransportation = handlingAndTransportation;
		return result;
	}
}
